import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { apiList } from '../../../locales/apiList';
import { translations } from '../../../locales/translations';
import { UseAxios } from '../../../utils/UseAxios';
import BarAndMenu from '../../components/BarAndMenu';

type Props = {};

const Wrapper = styled.div`
  font-size: 14px;
  height: 100%;
  padding-left: 72px;

  .content-container {
    padding: 20px;
  }
`;

const ReportPage = (props: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const getReport = async () => {
    setLoading(true);
    const getBIResult = await UseAxios(`${apiList.getReportURL}`, 'get');
    if (getBIResult && getBIResult.data) {
      window.open(getBIResult.data, '_blank');
    }
    setLoading(false);
  };

  return (
    <>
      <Wrapper>
        <BarAndMenu />
        <div className="content-container">
          <h1>{t(translations.report.title)}</h1>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="report-select-label">Select Report</InputLabel>
                <Select
                  labelId="report-select-label"
                  id="report-simple-select"
                  value={1}
                  label="Report"
                  // onChange={handleChange}
                >
                  <MenuItem value={1}>
                    {t(
                      translations.report.openContractPaymentReportStatusTitle,
                    )}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} display={'flex'} justifyContent={`flex-end`}>
              {loading ? (
                <CircularProgress />
              ) : (
                <Button variant="contained" onClick={() => getReport()}>
                  {t(translations.report.download)}
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </Wrapper>
    </>
  );
};

export default ReportPage;
